import React, { useState } from 'react';
import type { RoomRate } from '@niarab2c/frontend-commons/src/types/hotels';
import { ResponsiveTooltip } from '@niaratech/niara-react-components';
import { NiaraIcon } from '@niaratech/niara-icons';
import { Divider, Stack } from '@mui/material';
import ModalOTA, { type ModalOTAProps } from '../../components/ModalOTA';
import * as S from './styles';
interface InclusionsProps {
  inclusions?: RoomRate['ratePlan']['inclusions'];
  /**
   * @default 10
   */
  initialVisibleInclusions?: number;
}
const Inclusions: React.FC<InclusionsProps> = props => {
  const {
    inclusions,
    initialVisibleInclusions = 10
  } = props;
  const [showAmenitiesQuantity, setShowAmenitiesQuantity] = useState<number | undefined>(initialVisibleInclusions);
  const showingAllAmenities = showAmenitiesQuantity === undefined;
  if (inclusions?.length < 1) {
    return null;
  }
  return <S.InclusionContainer>
      {inclusions?.slice(0, showAmenitiesQuantity)?.map(inclusion => {
      return <ResponsiveTooltip<ModalOTAProps> modalComponent={ModalOTA} ModalProps={{
        title: inclusion?.name
      }} key={inclusion?.id} renderContent={() => <S.AmenityTooltip>
                <p className="bold">{inclusion?.name}</p>
                <p>{inclusion?.description}</p>
              </S.AmenityTooltip>}>
            <Stack direction="row" alignItems="start" gap={'5px'}>
              <span>
                <NiaraIcon icon="sysCheck" size={16} />
              </span>
              <S.Inclusion>{inclusion?.name}</S.Inclusion>
            </Stack>
          </ResponsiveTooltip>;
    })}
      {inclusions?.length > initialVisibleInclusions && <Stack direction="row" alignItems="center" gap={'5px'} alignSelf="center">
          <S.DividerContainer>
            <Divider orientation="vertical" sx={{
          margin: 0,
          borderColor: '#E6E6E6',
          width: '1px',
          height: '10px',
          display: 'flex'
        }} />
          </S.DividerContainer>
          <S.SeeAmenities onClick={() => {
        setShowAmenitiesQuantity(showingAllAmenities ? initialVisibleInclusions : undefined);
      }}>
            {showingAllAmenities ? "Ver menos" : "Ver mais"}
          </S.SeeAmenities>
        </Stack>}
    </S.InclusionContainer>;
};
export default Inclusions;